module.exports = __webpack_public_path__ + "img/bmcl_gallery7.35fa3e0b.jpg";